
export function calcularTokens(text) {
    if (!text) return 0;
  
    // Remove espaços extras no começo/fim
    text = text.trim();
  
    // Cada token tem em média 4 caracteres (incluindo espaços e pontuação)
    const mediaCaracteresPorToken = 3.91;
  
    return Math.ceil(text.length / mediaCaracteresPorToken);
}

